export const CLIENT_TYPE = {
  CLIENT: 'baseClient',
  DZMS_CLIENT: 'dzmsClient',
  VERD_CLIENT: 'verdClient',
};
